"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = exports.safeDateString = exports.safeStringToNumber = void 0;
const safeStringToNumber = (str) => {
    const num = Number(str !== null && str !== void 0 ? str : 0);
    if (isNaN(num))
        return 0;
    return num;
};
exports.safeStringToNumber = safeStringToNumber;
const safeDateString = (value) => {
    if (!value)
        return 'N/A';
    if (!/\d{4}-\d{2}(-\d{2})?/.test(value))
        return 'N/A';
    const [year, month, day = '01'] = value.split('-');
    return `${month}/${day}/${year}`;
};
exports.safeDateString = safeDateString;
const capitalize = (str) => {
    return str[0].toUpperCase() + str.slice(1);
};
exports.capitalize = capitalize;
//# sourceMappingURL=safe-strings.js.map